import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import {
  Box,
  Button,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@material-ui/core';
import { SportDTO } from '../../DTO';
import { stores } from 'mobx-store';
import AddEditSportModal from './SportForm';
import DeleteIcon from '@material-ui/icons/Delete';

const SportsScreen: React.FC = observer(() => {
  const { liveScoringStore } = stores;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedSport, setSelectedSport] = useState<SportDTO | null>(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [sportToDelete, setSportToDelete] = useState<SportDTO | null>(null);

  useEffect(() => {
    liveScoringStore.getSports();
  }, [liveScoringStore]);

  const handleOpenAdd = () => {
    setSelectedSport(null);
    setIsModalOpen(true);
  };

  const handleOpenEdit = (sport: SportDTO) => {
    setSelectedSport(sport);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    liveScoringStore.getSports(); // Refresh list
  };

  const handleOpenDeleteDialog = (sport: SportDTO) => {
    setSportToDelete(sport);
    setDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setSportToDelete(null);
  };

  const handleConfirmDelete = async () => {
    if (sportToDelete && sportToDelete?.id) {
      await liveScoringStore.deleteSport(sportToDelete.id);
      handleCloseDeleteDialog();
    }
  };

  return (
    <Container>
      <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="h4" gutterBottom>
          Sports Management
        </Typography>
        <Button variant="contained" color="primary" onClick={handleOpenAdd}>
          Add New Sport
        </Button>
      </Box>

      <TableContainer component={Paper} style={{ marginTop: 20 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Short Name</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {liveScoringStore.sports.map((sport) => (
              <TableRow key={sport.id}>
                <TableCell>{sport.id}</TableCell>
                <TableCell>{sport.name}</TableCell>
                <TableCell>{sport.nameShort}</TableCell>
                <TableCell align="right">
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => handleOpenEdit(sport)}
                    style={{ marginRight: 8 }}
                  >
                    Edit
                  </Button>
                  <IconButton
                    color="default"
                    onClick={() => handleOpenDeleteDialog(sport)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <AddEditSportModal
        open={isModalOpen}
        onClose={handleCloseModal}
        sport={selectedSport}
      />

      {/* Delete Confirmation Dialog */}
      <Dialog open={deleteDialogOpen} onClose={handleCloseDeleteDialog}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete{' '}
            {sportToDelete?.name || 'this sport'}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="secondary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
});

export default SportsScreen;
